'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.init = init;

var _modal = require('../components/modal/modal.js');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');
  var modals = context.getElements('.' + context.className + '_Modal');

  var dynamicBullets = {};

  if (modals.length > 5) {
    dynamicBullets = {
      dynamicBullets: true,
      dynamicMainBullets: 3
    };
  }

  makeCarousel();

  function makeCarousel() {
    (0, _utils.initialiseSwiper)(swiperContainer, {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: 1.9,
      slidesOffsetBefore: 0,
      centeredSlides: true,
      initialSlide: 1,
      spaceBetween: 15,
      speed: 500,
      slideClass: context.className + '_Slide',
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesOffsetBefore: 0,
          centeredSlides: true
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 30,
          slidesOffsetBefore: 120,
          centeredSlides: false
        },
        1400: {
          slidesPerView: 3.3,
          spaceBetween: 30,
          slidesOffsetBefore: 110,
          centeredSlides: false
        }
      },
      autoplay: {
        delay: 3000
      },
      pagination: (0, _assign2.default)({
        el: context.getElement('.swiper-pagination')
      }, dynamicBullets),
      navigation: {
        nextEl: '.' + context.className + '_Next',
        prevEl: '.' + context.className + '_Prev'
      }
    }, ['Navigation', 'Pagination', 'Autoplay']);

    /**
     * Modals need to be initialised after carousel because
     * slides get duplicated and we need the trigger buttons to be there
     * to add the event listeners
     */
    modals.map(function (modal) {
      return new _modal.Modal(modal);
    });
  }
}